<div class="card">
    <div class="card-header">
        <h4>Merchant Accounts</h4>
    </div>
    <div class="card-body m-0">
        <div class="row g-9 mb-8">
            <div class="row">
                <div class="col-md-4">
                    <label class="col-form-label" for="businessType">
                        <span class="">Business Type</span>
                    </label>
                    <ng-select id="businessType" placeholder="Select Busniess Type" [inputAttrs]="{maxlength: '100'}" [(ngModel)]="businessType">
                        <ng-option value="ALL">ALL</ng-option>
                        <ng-option *ngFor="let item of businessTypes" value="{{item.key}}">{{item.title}}</ng-option>
                    </ng-select>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="card mt-4">
    <div class="card-body m-0">

        <div class="row text-end">
            <div class="col-xl-4">
                <input type="text" [(ngModel)]="globalSearch" class="form-control" id="roleNameSearch"
                    placeholder="Search" (ngModelChange)="onSearchChange($event)" />
            </div>
            <div class="col-xl-8">
                <div class="btn-group mb-1 mb-md-0">
                    <div class="btn-group" ngbDropdown role="group">
                        <button type="button" class="btn bg-danger-custom" ngbDropdownToggle>
                            Export <i class="feather icon-download"></i>
                        </button>
                        <div ngbDropdownMenu class="ng-dropdown-panel-items p-1" style="height: 100px;width: 200px;">
                            <div class="form-group">
                                <div class="list-group ng-option">
                                    <a href="javascript:void(0)" (click)="exportAsCsv()">
                                        <span class="checkbox">
                                            <label class="list-group-item p-2" style="cursor: pointer;">CSV</label>
                                        </span>
                                    </a>
                                    <a href="javascript:void(0)" class="mt-2" (click)="exportAsExcel()">
                                        <span class="checkbox">
                                            <label class="list-group-item p-2" style="cursor: pointer;">Excel</label>
                                        </span>
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="btn-group mb-1 mb-md-0">
                    <div class="btn-group" ngbDropdown role="group">
                        <button class="btn bg-danger-custom" ngbDropdownToggle>Customize Columns</button>
                        <div ngbDropdownMenu class="ng-dropdown-panel-items p-1"
                            style="height: 250px;width: 250px; overflow: scroll; scroll-behavior: smooth">
                            <div class="form-group">
                                <div *ngIf="columnDefs" class="list-group ng-option">
                                    <span *ngFor="let column of columnDefsCopy; let i = index" class="checkbox">
                                        <label class="list-group-item p-2">
                                            <input class="form-check-input me-1" type="checkbox" value="{{i}}"
                                                name="{{column.headerName}}" [checked]="!column.hide"
                                                (change)="hideColumn($event,column.field)" />
                                            {{(column?.headerName?.replace('_','') || column?.field?.replace('_','') )}}
                                        </label>
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="row mt-3" style="min-height: 360px">
            <div class="col-12 col-xl-12 grid-margin stretch-card ag-theme-alpine" style="margin-bottom: 0px">
                <ag-grid-angular [enableCellTextSelection]=true (gridReady)="onGridReady($event)"
                    [columnDefs]="columnDefs" [defaultColDef]="defaultColDef" [tooltipShowDelay]="0"
                    [enableCellTextSelection]=true [rowData]="rowData" [rowModelType]="" [rowSelection]="'single'"
                    [gridOptions]="gridOptions" style="width: 100%; height: auto;" [pagination]="true" [paginationPageSize]="pageRecords" >
                </ag-grid-angular>
            </div>
        </div>
    </div>
</div>